import { Bubble } from 'js/bubbleCore/bubbles/types';
import { testCircleRectangleCollision } from 'js/framework/utils/collision-utils';
import { IPopOutSpaceData } from 'js/bubbleCore/types';
import {
  IEvent,
  createBubbleBouncerCollisionEvent,
  createBubblePointZoneCollisionEvent,
} from 'js/bubbleCore/events';
import {
  IRectangle,
  isRectangleContaining
} from 'js/framework/utils/math-utils';
import { loopSpace } from 'js/bubbleCore/utils/loopSpace';


export function checkPopOutCollisions(
  space: IPopOutSpaceData,
  events: IEvent[] = [],
): void {
  loopSpace(space, (bubble) => {
    space.bouncers.forEach((bouncer) => {
      if (testBubbleRectCollision(bubble, bouncer.size)) {
        events.push(createBubbleBouncerCollisionEvent(bubble, bouncer));
      }
    });

    space.pointZones.forEach((pointZone) => {
      if (isRectangleContaining(bubble.hexSpaceX, bubble.hexSpaceY, pointZone.rect)) {
        events.push(createBubblePointZoneCollisionEvent(bubble, pointZone));
      }
    });
  });
}


export function testBubbleRectCollision(bubble: Bubble, rect: IRectangle): boolean {
  return testCircleRectangleCollision(
    {
      x: bubble.hexSpaceX,
      y: bubble.hexSpaceY,
      radius: bubble.radiusInGrid,
    },
    rect
  )
}
